<template>
  <div :class="classModifiers" v-if="ready">
    <div class="election-map-special__label">GA Special:</div>
    <transition name="election-map-special">
      <div v-if="showTooltip && isLayoutDesktop" class="election-map-special__tooltip">
        <market-state-tooltip
          stateCode="GA2"
          stateName="Georgia"
          :marketData="ga2MarketData"
          type="senate"
        ></market-state-tooltip>
      </div>
    </transition>
    <div
      class="election-map-special__legend"
      :style="legendStyleModifiers"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
      @click="onClick"
    >
      <template v-if="targetContractInstance.hasLastTradePrice">
        <animated-number :value="targetContractInstance.lastTradePriceAsCents"></animated-number>
      </template>
      <template v-else> - </template>
    </div>
  </div>
</template>

<script src="./election-map-special.js"></script>
<style src="./election-map-special.scss" lang="scss"></style>
